(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["qonfi-company-car-flow"] && !Shopify.designMode) return;
  try {
      
  document.addEventListener('DOMContentLoaded', () => {
    const params = new URLSearchParams(window.location.search);
    const qonfiSubmitted = params.get("qonfi-submitted");
    
    const secureSessionId = crypto.randomUUID();
    
    const resetButton = document.querySelector('[data-reset-qonfi]');
  
    console.log({
      qonfiSubmitted,
      randomNumber: secureSessionId,
      test: !qonfiSubmitted || qonfiSubmitted !== "true"
    })
  
    // if on Qonfi "step" we set sessionId store sessionId
    if (!qonfiSubmitted || qonfiSubmitted !== "true") {
      window.qonfiVariables = {
        "sessionId": secureSessionId
      };
      
      sessionStorage.setItem("qonfiCompanyCarSessionId", secureSessionId);
    };

    // toggle which form is visible
    setTimeout(()=>{
      const nextForm = document.querySelector('.qonfi-level-2-company-car');
      const qonfiForm = document.querySelector('[data-qonfi-uuid]');

      if (qonfiSubmitted && qonfiSubmitted === "true") {
        nextForm && (nextForm.style.display = 'block');
        resetButton && (resetButton.removeAttribute('aria-hidden'));
      } else {
        qonfiForm && (qonfiForm.style.display = 'block');
        resetButton && (resetButton.setAttribute('aria-hidden', 'true'));
      };
      
      console.log('sessionId', sessionStorage.getItem("qonfiCompanyCarSessionId"));
    }, 1000);
    
    // reset qonfi
    if (resetButton) {
      resetButton.addEventListener('click', () => {
        sessionStorage.removeItem("qonfiCompanyCarSessionId");
        window.qonfiVariables = {
          "sessionId": ''
        };
        
        window.location.search = '';
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qonfi-to-embed-form-flow"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const params = new URLSearchParams(window.location.search);
    const isSubmitted = params.get("qonfi-submitted") === "true";
    const root = document.documentElement;

    function safeGet(key) {
      try { return sessionStorage.getItem(key); } catch (e) { return null; }
    }
    function safeSet(key, value) {
      try { sessionStorage.setItem(key, value); } catch (e) { console.warn('sessionStorage utilgaengelig', e); }
    }
    function safeRemove(key) {
      try { sessionStorage.removeItem(key); } catch (e) {}
    }

    function createSessionId() {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') {
        return window.crypto.randomUUID();
      }
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = Math.random() * 16 | 0;
        const v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    }

    const existingSessionId = safeGet("qonfiSessionId");
    let state;

    if (!isSubmitted) {
      // Qonfi-step: opret og gem nyt sessionId
      const sessionId = createSessionId();
      window.qonfiVariables = { "sessionId": sessionId };
      safeSet("qonfiSessionId", sessionId);
      state = 'qonfi-step-start';
    } else if (existingSessionId) {
      // Formular-step med gyldigt sessionId
      window.qonfiVariables = { "sessionId": existingSessionId };
      state = 'qonfi-step-submitted';
    } else {
      // Formular-step uden sessionId: vis ikke formularen
      state = 'qonfi-step-missing';
    }

    root.classList.add(state);

    function init() {
      const resetButton = document.querySelector('[data-reset-qonfi]');
      const resetBtnEl = resetButton && resetButton.querySelector('button');

      if (resetBtnEl) {
        if (isSubmitted) {
          resetBtnEl.removeAttribute('aria-hidden');
        } else {
          resetBtnEl.setAttribute('aria-hidden', 'true');
        }
      }

      if (resetButton) {
        resetButton.addEventListener('click', function () {
          safeRemove("qonfiSessionId");
          window.qonfiVariables = { "sessionId": '' };
          window.location.search = '';
        });
      }

      console.log('qonfi', { state: state, sessionId: safeGet("qonfiSessionId") });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
